<template>
    <v-container fluid>
        <div class="text-center">
            <v-btn color="success" @click="exportExcel">
                <v-icon left>mdi-file-excel</v-icon> Export Excel
            </v-btn>
        </div>
        <v-textarea
            autofocus
            label="hãy dùng máy quét"
            rows="20"
            v-model="vText"
            type="search"
            enterkeyhint="done"
        ></v-textarea>
    </v-container>
</template>

<script>
let styleNumber = {
    alignment: { horizontal: "right" },
    numFmt: "#,##0",
};

const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            excel: {
                exportData: "views/excel/exportData",
            },
        },
        stock: {
            columns: [
                { header: "Mã hàng", key: "qrcode", width: 25 },
                {
                    header: "Số lượng",
                    key: "amount",
                    width: 15,
                    style: styleNumber,
                },
            ],
        },
    },
};
const df = cafe.default;

export default {
    name: "Home",

    components: {},

    // this is state
    data() {
        return {
            vText: "",
            vObj: {},
        };
    },

    watch: {
        vText: function (val) {
            let arr = val.split("\n");
            let x = arr.length - 1;
            let iLast = arr[x];
            if (iLast) return;
            let list = [];
            let vObj = {};
            for (let line of arr) {
                if (!line) continue;
                let subArr = line.split("\t");
                let qrcode = subArr[0];
                let amount = 1;
                if (subArr.length > 1) amount = parseInt(subArr[1], 10);
                let obj = vObj[qrcode];
                if (!obj) obj = { qrcode, amount };
                else obj.amount += 1;
                vObj[qrcode] = obj;
            }
            let keys = Object.keys(vObj);
            for (let qrcode of keys) {
                let { amount } = vObj[qrcode];
                let line = `${qrcode}\t${amount}`;
                list.push(line);
            }
            this.vText = `${list.join("\n")}\n`;
            this.vObj = vObj;
        },
    },

    computed: {
        ua() {
            return this.$store.state.useragent;
        },
    },

    methods: {
        async exportExcel() {
            const dp = this.$store.dispatch;
            let fileName = "stock-data.xlsx";
            let worksheet = {
                name: "sheet1",
                views: [
                    {
                        state: "frozen",
                        xSplit: 1,
                        ySplit: 1,
                        activeCell: "A1",
                    },
                ],
            };
            let rows = [];
            let keys = Object.keys(this.vObj);
            for (let qrcode of keys) {
                let item = this.vObj[qrcode];
                rows.push(item);
            }
            let sheet01 = {
                sheetName: "sheet.test",
                columns: df.stock.columns,
                config: { worksheet },
                rows,
            };
            let payload = { fileName, data: [sheet01] };
            let res_export = await dp(df.sp.excel.exportData, payload);
            console.log("res_export", res_export);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// tool.stock.scan.vue